import logger from './logger';
/**
 * Thin helpers around react-google-recaptcha-v3's `executeRecaptcha`.
 * Callers get `executeRecaptcha` from the `useGoogleReCaptcha()` hook
 * (the app is wrapped in `<GoogleReCaptchaProvider>` in src/index.js)
 * and pass it in here rather than reaching into `window.grecaptcha` directly.
 */

export const OTP_RECAPTCHA_ACTION = 'send_otp';

export const getRecaptchaToken = async (executeRecaptcha, action = 'booking') => {
  if (!executeRecaptcha) {
    logger.warn('reCAPTCHA is not ready yet');
    return null;
  }

  try {
    return await executeRecaptcha(action);
  } catch (error) {
    logger.error('Failed to get reCAPTCHA token:', error);
    return null;
  }
};

export const addRecaptchaToken = async (executeRecaptcha, data, action = 'booking') => {
  const token = await getRecaptchaToken(executeRecaptcha, action);
  if (typeof token !== 'string' || !token.trim()) {
    throw new Error('Unable to complete the security check. Please try again.');
  }
  return { ...data, recaptcha_token: token };
};
